import { ReferencePortfolio } from '@ndvr/portfolio-api';

// Use client-portal/client/utils/i18n/portfolio-i18n.ts as source of truth
const shortRefPortfolioNames: { [key: string]: string } = {
    [ReferencePortfolio.RB_US_2Y]: '10% U.S. Equities, 90% Very Short-Term Bonds',
    [ReferencePortfolio.RB_US_5Y]: '20% U.S. Equities, 80% Short-Term Bonds',
    [ReferencePortfolio.RB_US_7Y]: '33% U.S. Equities, 67% 7yr Bonds',
    [ReferencePortfolio.RB_US_10Y]: '35% U.S. Equities, 65% Intermediate-Term Bonds',
    [ReferencePortfolio.RB_US_20Y]: '50% U.S. Equities, 50% Long-Term Bonds',
    [ReferencePortfolio.RB_US_30Y]: '60% U.S. Equities, 40% Very Long-Term Bonds',

    [ReferencePortfolio.RB_GLOBAL_2Y]: '10% Global Equities, 90% Very Short-Term Bonds',
    [ReferencePortfolio.RB_GLOBAL_5Y]: '20% Global Equities, 80% Short-Term Bonds',
    [ReferencePortfolio.RB_GLOBAL_7Y]: '33% Global Equities, 67% 7yr Bonds',
    [ReferencePortfolio.RB_GLOBAL_10Y]: '35% Global Equities, 65% Intermediate-Term Bonds',
    [ReferencePortfolio.RB_GLOBAL_20Y]: '50% Global Equities, 50% Long-Term Bonds',
    [ReferencePortfolio.RB_GLOBAL_30Y]: '60% Global Equities, 40% Very Long-Term Bonds',

    [ReferencePortfolio.LEVERAGED_RB_US_10Y_ULTRA]:
        '2.0x Leveraged Risk-Balanced: 10yr Ultra Bond Futures & U.S. Equities',
    [ReferencePortfolio.LEVERAGED_RB_US_10Y_ULTRA_VIX]: 'U.S. Growth with Embedded Alternatives',
    [ReferencePortfolio.LEVERAGED_RB_US_10Y_VIX_7525]: '75% U.S. Equities, 25% Enhanced Treasuries',
    [ReferencePortfolio.LEVERAGED_RB_US_20Y]: '1.50x Leveraged Risk-Balanced: 20yr Bond Futures & U.S. Equities',
    [ReferencePortfolio.LEVERAGED_RB_US_20Y_VIX]: 'U.S. 75/75 Levered',

    [ReferencePortfolio.LEVERAGED_RB_GLOBAL_10Y_ULTRA]:
        '2.0x Leveraged Risk-Balanced: 10yr Ultra Bond Futures & Global Equities',
    [ReferencePortfolio.LEVERAGED_RB_GLOBAL_10Y_ULTRA_VIX]: 'Global Growth with Embedded Alternatives',
    [ReferencePortfolio.LEVERAGED_RB_GLOBAL_10Y_VIX_7525]: '75% Global Equities, 25% Enhanced Treasuries',
    [ReferencePortfolio.LEVERAGED_RB_GLOBAL_20Y]: '1.50x Leveraged Risk-Balanced: 20yr Bond Futures & Global Equities',
    [ReferencePortfolio.LEVERAGED_RB_GLOBAL_20Y_VIX]: 'Global 75/75 Levered',

    [ReferencePortfolio.US_EQ_75_LEVERED_BOND_25]: 'Leveraged 75/25: U.S. Equities & Leveraged Bond ETF',
    [ReferencePortfolio.GLOBAL_EQ_75_LEVERED_BOND_25]: 'Leveraged 75/25: Global Equities & Leveraged Bond ETF',

    [ReferencePortfolio.EQ_US]: '100% NDVR U.S. Equities',
    [ReferencePortfolio.EQ_GLOBAL]: '100% NDVR Global Equities',

    [ReferencePortfolio.EQ_US_BENCHMARK_NO_FEE]: '100% U.S. Passive Equities',
    [ReferencePortfolio.US_60_40_BENCHMARK_CUSTOM_FEE]: 'Traditional 60% U.S. Equities, 40% Bonds',
    [ReferencePortfolio.MODEL_US_70_30]: 'Traditional 70% U.S. Equities, 30% Bonds',
    [ReferencePortfolio.EQ_GLOBAL_BENCHMARK_NO_FEE]: '100% Global Passive Equities',
    [ReferencePortfolio.GLOBAL_60_40_BENCHMARK_CUSTOM_FEE]: 'Traditional 60% Global Equities, 40% Bonds',
    [ReferencePortfolio.MODEL_GLOBAL_70_30]: 'Traditional 70% Global Equities, 30% Bonds',

    [ReferencePortfolio.FI_2Y]: '100% 2yr Bonds',
    [ReferencePortfolio.FI_5Y]: '100% 5yr Bonds',
    [ReferencePortfolio.FI_7Y]: '100% 7yr Bonds',
    [ReferencePortfolio.FI_10Y]: '100% 10yr Bonds',
    [ReferencePortfolio.FI_20Y]: '100% 20yr Bonds',
    [ReferencePortfolio.FI_30Y]: '100% 30yr Bonds',

    [ReferencePortfolio.US_EQ_60_FI2Y_40]: '60% U.S. Equities, 40% Very Short-Term Bonds',
    [ReferencePortfolio.US_EQ_35_FI5Y_65]: '35% U.S. Equities, 65% Short-Term Bonds',
    [ReferencePortfolio.US_EQ_80_FI10Y_20]: '80% U.S. Equities, 20% Intermediate-Term Bonds',
    [ReferencePortfolio.US_EQ_70_FI10Y_30]: '70% U.S. Equities, 30% Intermediate-Term Bonds',
    [ReferencePortfolio.US_EQ_40_FI10Y_60]: '40% U.S. Equities, 60% Intermediate-Term Bonds',
    [ReferencePortfolio.US_EQ_60_FI10Y_40]: '60% U.S. Equities, 40% Intermediate-Term Bonds',
    [ReferencePortfolio.US_EQ_75_FI2Y_25]: '75% U.S. Equities, 25% Very Short-Term Bonds',
    [ReferencePortfolio.US_EQ_75_FI10Y_25]: '75% U.S. Equities, 25% Intermediate-Term Bonds',

    [ReferencePortfolio.GLOBAL_EQ_60_FI2Y_40]: '60% Global Equities, 40% Very Short-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_35_FI5Y_65]: '35% Global Equities, 65% Short-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_80_FI10Y_20]: '80% Global Equities, 20% Intermediate-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_70_FI10Y_30]: '70% Global Equities, 30% Intermediate-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_60_FI10Y_40]: '60% Global Equities, 40% Intermediate-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_40_FI10Y_60]: '40% Global Equities, 60% Intermediate-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_50_FI2Y_50]: '50% Global Equities, 50% Very Short-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_50_FI10Y_50]: '50% Global Equities, 50% Intermediate-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_45_FI10Y_55]: '45% Global Equities, 55% Intermediate-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_75_FI2Y_25]: '75% Global Equities, 25% Very Short-Term Bonds',
    [ReferencePortfolio.GLOBAL_EQ_75_FI10Y_25]: '75% Global Equities, 25% Intermediate-Term Bonds',

    [ReferencePortfolio.TREASURY_FUTURES_20Y]: 'Treasury Futures 20yr',
    [ReferencePortfolio.DO_NOT_TRADE]: 'Do Not Trade',
    [ReferencePortfolio.JUST_CASH]: 'Cash',
    [ReferencePortfolio.NOT_SET]: 'Not Set',

    [ReferencePortfolio.CLIENT_DIRECTED]: 'Client Directed',
    [ReferencePortfolio.CUSTOM_WEIGHTS]: 'Portfolio-management Custom Portfolio',
    [ReferencePortfolio.EXTERNALLY_MANAGED]: 'Externally managed Portfolio',
    [ReferencePortfolio.HEDGED_EQUITY]: 'Hedged Equity',
    [ReferencePortfolio.SHORT_TERM_TREASURIES]: 'Short-Term Treasuries',
    [ReferencePortfolio.SHORT_TERM_TREASURIES_1Y]: '1yr Short-Term Treasuries',

    [ReferencePortfolio.MOCK_LEVERAGED_RB_GLOBAL_10Y_ULTRA_VIX]:
        'Mock 75% Global Equities, 125% Enhanced Intermediate-Term Bonds',
    [ReferencePortfolio.MOCK_LEVERAGED_RB_GLOBAL_20Y_VIX]: 'Mock Global 75/75 Levered',
    [ReferencePortfolio.MOCK_2Y_UST_90_EQ_10]: 'Mock 2Y 90% U.S. Treasuries, 10% U.S. Equities',
    [ReferencePortfolio.MOCK_2Y_UST_80_EQ_20]: 'Mock 2Y 80% U.S. Treasuries, 20% U.S. Equities',
    [ReferencePortfolio.MOCK_2Y_UST_70_EQ_30]: 'Mock 2Y 70% U.S. Treasuries, 30% U.S. Equities',
    [ReferencePortfolio.MOCK_2Y_UST_60_EQ_40]: 'Mock 2Y 60% U.S. Treasuries, 40% U.S. Equities',
    [ReferencePortfolio.MOCK_2Y_UST_50_EQ_50]: 'Mock 2Y 50% U.S. Treasuries, 50% U.S. Equities',
    [ReferencePortfolio.MOCK_2Y_UST_40_EQ_60]: 'Mock 2Y 40% U.S. Treasuries, 60% U.S. Equities',
    [ReferencePortfolio.MOCK_2Y_UST_30_EQ_70]: 'Mock 2Y 30% U.S. Treasuries, 70% U.S. Equities',
    [ReferencePortfolio.MOCK_2Y_UST_20_EQ_80]: 'Mock 2Y 20% U.S. Treasuries, 80% U.S. Equities',
    [ReferencePortfolio.MOCK_2Y_UST_10_EQ_90]: 'Mock 2Y 10% U.S. Treasuries, 90% U.S. Equities',
    [ReferencePortfolio.MOCK_5Y_UST_90_EQ_10]: 'Mock 5Y 90% U.S. Treasuries, 10% U.S. Equities',
    [ReferencePortfolio.MOCK_5Y_UST_80_EQ_20]: 'Mock 5Y 80% U.S. Treasuries, 20% U.S. Equities',
    [ReferencePortfolio.MOCK_5Y_UST_70_EQ_30]: 'Mock 5Y 70% U.S. Treasuries, 30% U.S. Equities',
    [ReferencePortfolio.MOCK_5Y_UST_60_EQ_40]: 'Mock 5Y 60% U.S. Treasuries, 40% U.S. Equities',
    [ReferencePortfolio.MOCK_5Y_UST_50_EQ_50]: 'Mock 5Y 50% U.S. Treasuries, 50% U.S. Equities',
    [ReferencePortfolio.MOCK_5Y_UST_40_EQ_60]: 'Mock 5Y 40% U.S. Treasuries, 60% U.S. Equities',
    [ReferencePortfolio.MOCK_5Y_UST_30_EQ_70]: 'Mock 5Y 30% U.S. Treasuries, 70% U.S. Equities',
    [ReferencePortfolio.MOCK_5Y_UST_20_EQ_80]: 'Mock 5Y 20% U.S. Treasuries, 80% U.S. Equities',
    [ReferencePortfolio.MOCK_5Y_UST_10_EQ_90]: 'Mock 5Y 10% U.S. Treasuries, 90% U.S. Equities',
    [ReferencePortfolio.MOCK_7Y_UST_90_EQ_10]: 'Mock 7Y 90% U.S. Treasuries, 10% U.S. Equities',
    [ReferencePortfolio.MOCK_7Y_UST_80_EQ_20]: 'Mock 7Y 80% U.S. Treasuries, 20% U.S. Equities',
    [ReferencePortfolio.MOCK_7Y_UST_70_EQ_30]: 'Mock 7Y 70% U.S. Treasuries, 30% U.S. Equities',
    [ReferencePortfolio.MOCK_7Y_UST_60_EQ_40]: 'Mock 7Y 60% U.S. Treasuries, 40% U.S. Equities',
    [ReferencePortfolio.MOCK_7Y_UST_50_EQ_50]: 'Mock 7Y 50% U.S. Treasuries, 50% U.S. Equities',
    [ReferencePortfolio.MOCK_7Y_UST_40_EQ_60]: 'Mock 7Y 40% U.S. Treasuries, 60% U.S. Equities',
    [ReferencePortfolio.MOCK_7Y_UST_30_EQ_70]: 'Mock 7Y 30% U.S. Treasuries, 70% U.S. Equities',
    [ReferencePortfolio.MOCK_7Y_UST_20_EQ_80]: 'Mock 7Y 20% U.S. Treasuries, 80% U.S. Equities',
    [ReferencePortfolio.MOCK_7Y_UST_10_EQ_90]: 'Mock 7Y 10% U.S. Treasuries, 90% U.S. Equities',
    [ReferencePortfolio.MOCK_10Y_UST_90_EQ_10]: 'Mock 10Y 90% U.S. Treasuries, 10% U.S. Equities',
    [ReferencePortfolio.MOCK_10Y_UST_80_EQ_20]: 'Mock 10Y 80% U.S. Treasuries, 20% U.S. Equities',
    [ReferencePortfolio.MOCK_10Y_UST_70_EQ_30]: 'Mock 10Y 70% U.S. Treasuries, 30% U.S. Equities',
    [ReferencePortfolio.MOCK_10Y_UST_60_EQ_40]: 'Mock 10Y 60% U.S. Treasuries, 40% U.S. Equities',
    [ReferencePortfolio.MOCK_10Y_UST_50_EQ_50]: 'Mock 10Y 50% U.S. Treasuries, 50% U.S. Equities',
    [ReferencePortfolio.MOCK_10Y_UST_40_EQ_60]: 'Mock 10Y 40% U.S. Treasuries, 60% U.S. Equities',
    [ReferencePortfolio.MOCK_10Y_UST_30_EQ_70]: 'Mock 10Y 30% U.S. Treasuries, 70% U.S. Equities',
    [ReferencePortfolio.MOCK_10Y_UST_20_EQ_80]: 'Mock 10Y 20% U.S. Treasuries, 80% U.S. Equities',
    [ReferencePortfolio.MOCK_10Y_UST_10_EQ_90]: 'Mock 10Y 10% U.S. Treasuries, 90% U.S. Equities',
    [ReferencePortfolio.MOCK_20Y_UST_90_EQ_10]: 'Mock 20Y 90% U.S. Treasuries, 10% U.S. Equities',
    [ReferencePortfolio.MOCK_20Y_UST_80_EQ_20]: 'Mock 20Y 80% U.S. Treasuries, 20% U.S. Equities',
    [ReferencePortfolio.MOCK_20Y_UST_70_EQ_30]: 'Mock 20Y 70% U.S. Treasuries, 30% U.S. Equities',
    [ReferencePortfolio.MOCK_20Y_UST_60_EQ_40]: 'Mock 20Y 60% U.S. Treasuries, 40% U.S. Equities',
    [ReferencePortfolio.MOCK_20Y_UST_50_EQ_50]: 'Mock 20Y 50% U.S. Treasuries, 50% U.S. Equities',
    [ReferencePortfolio.MOCK_20Y_UST_40_EQ_60]: 'Mock 20Y 40% U.S. Treasuries, 60% U.S. Equities',
    [ReferencePortfolio.MOCK_20Y_UST_30_EQ_70]: 'Mock 20Y 30% U.S. Treasuries, 70% U.S. Equities',
    [ReferencePortfolio.MOCK_20Y_UST_20_EQ_80]: 'Mock 20Y 20% U.S. Treasuries, 80% U.S. Equities',
    [ReferencePortfolio.MOCK_20Y_UST_10_EQ_90]: 'Mock 20Y 10% U.S. Treasuries, 90% U.S. Equities',
    [ReferencePortfolio.MOCK_30Y_UST_90_EQ_10]: 'Mock 30Y 90% U.S. Treasuries, 10% U.S. Equities',
    [ReferencePortfolio.MOCK_30Y_UST_80_EQ_20]: 'Mock 30Y 80% U.S. Treasuries, 20% U.S. Equities',
    [ReferencePortfolio.MOCK_30Y_UST_70_EQ_30]: 'Mock 30Y 70% U.S. Treasuries, 30% U.S. Equities',
    [ReferencePortfolio.MOCK_30Y_UST_60_EQ_40]: 'Mock 30Y 60% U.S. Treasuries, 40% U.S. Equities',
    [ReferencePortfolio.MOCK_30Y_UST_50_EQ_50]: 'Mock 30Y 50% U.S. Treasuries, 50% U.S. Equities',
    [ReferencePortfolio.MOCK_30Y_UST_40_EQ_60]: 'Mock 30Y 40% U.S. Treasuries, 60% U.S. Equities',
    [ReferencePortfolio.MOCK_30Y_UST_30_EQ_70]: 'Mock 30Y 30% U.S. Treasuries, 70% U.S. Equities',
    [ReferencePortfolio.MOCK_30Y_UST_20_EQ_80]: 'Mock 30Y 20% U.S. Treasuries, 80% U.S. Equities',
    [ReferencePortfolio.MOCK_30Y_UST_10_EQ_90]: 'Mock 30Y 10% U.S. Treasuries, 90% U.S. Equities',
    [ReferencePortfolio.MOCK_PYFORECAST_EQ_GLOBAL]: 'PyForecast NDVR 100% Global Equities',
    [ReferencePortfolio.MOCK_PYFORECAST_RB_US_30Y]: 'PyForecast 60% U.S. Equities, 40% Very Long-Term Bonds',
    [ReferencePortfolio.MOCK_PYFORECAST_LEVERAGED_RB_GLOBAL_10Y_ULTRA_VIX]:
        'PyForecast 75% Global Equities with Growth-Enhanced Bonds',
};

export const REFERENCE_PORTFOLIOS: { [key: string]: string } = { ...ReferencePortfolio, ...shortRefPortfolioNames };
